import {
    ProcessStage,
    ProcessStageArrow,
    ProcessStageArrowDirection,
    ProcessStageOrder,
    useProcessController
} from "../../Processes";
import * as React from "react";
import {Notification} from "@vebox/etui-core";
import {defaultTheme} from "@vebox/etui-themes";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {FormCardFooter} from "../../common";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {MassiveActionProcessState} from "../MassiveActionsProvider";

declare var AppTranslations: AppTranslations;

const removeCodesDuplicates = (codes: string[]): string[] => {
    return codes.filter((eqCode, index, self) => {
        return index === self.findIndex((duplicateCode) => eqCode === duplicateCode)
    })
}

interface CodesValidationProps {
    validationFunction: (codes: string[]) => Promise<any[]>
    stepNumber: number
    stageOrder: ProcessStageOrder
    title: string
    cardTitle: string
    errorMessage: string
    errorDescription: string
    massiveActionProcessState: MassiveActionProcessState
}

const areEquals = (defaultText: string, newText: string) => {
    return defaultText === newText;
}

export const CodesValidation: React.FC<CodesValidationProps> = ({
                                                                    validationFunction,
                                                                    stepNumber,
                                                                    title,
                                                                    cardTitle,
                                                                    stageOrder,
                                                                    errorDescription,
                                                                    errorMessage,
                                                                    massiveActionProcessState
                                                                }) => {
    const translations = AppTranslations.massiveActions.massiveActionsCommon
    const processController = useProcessController();

    const [loading, setLoading] = React.useState<boolean>(false);
    const [hasBeenValidate, setHasBeenValidate] = React.useState<boolean>(false);
    const [textareaContent, setTextareaContent] = React.useState<string>();
    const [validateCodes, setValidateCodes] = React.useState<string>();

    const resetAll = () => {
        setHasBeenValidate(false);
        setTextareaContent("")
        setValidateCodes(undefined)
    }

    const reset = () => setTextareaContent("");
    const changeTextAreaContent = e => {
        setTextareaContent(e.target.value);
    }

    const goToNext = () => {
        const codes = textareaContent.split("\n").filter(Boolean);
        setLoading(true);
        setHasBeenValidate(false);
        setValidateCodes(textareaContent)
        validationFunction(removeCodesDuplicates(codes))
            .then(() => processController.goTo(processController.position + 1))
            .then(() => {
                setLoading(false)
                setHasBeenValidate(true);
            })
            .catch((e) => {
                setLoading(false);
                Notification.open({
                    type: "error",
                    message: errorMessage,
                    description: errorDescription,
                    duration: 10000,
                    theme: defaultTheme,
                });
            });
    };

    React.useEffect(() => {
        if (massiveActionProcessState === MassiveActionProcessState.INITIAL) {
            resetAll()
        }
    }, [massiveActionProcessState])

    return (
        <ProcessStage
            stepNumber={stepNumber}
            title={title}
            stageOrder={stageOrder}
        >
            <div className={"flx-row"}>
                <ProcessStageArrow stepNumber={stepNumber} direction={ProcessStageArrowDirection.BACKWARD}/>
                <VeBoxCard className={"form-card flx-col"}>
                    <h2 className={"bold card-title"}>{cardTitle}</h2>
                    <textarea
                        className={"codes-input-textarea"}
                        value={textareaContent}
                        onChange={changeTextAreaContent}
                        placeholder={"0000000000001\n0000000000002\n0000000000003..."}
                    />
                    <FormCardFooter
                        onReset={reset}
                        onNext={goToNext}
                        loading={loading}
                        loadable={true}
                        disabled={!textareaContent}
                        nextButtonText={translations.validatesCodes}
                    />
                </VeBoxCard>
                <ProcessStageArrow
                    stepNumber={stepNumber}
                    direction={ProcessStageArrowDirection.FORWARD}
                    visible={hasBeenValidate && areEquals(validateCodes, textareaContent)}
                />
            </div>
        </ProcessStage>
    );
}